import React from 'react';
import ExpenseReportFunctional from './components/expense-report-list-functional';
import './expense-report.scss';

const ExpenseReport = () => {
	return <ExpenseReportFunctional />;
};

export default ExpenseReport;
